import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { startEditNote } from '../../actions/favoriteEntities/notes';
import { EditButton, IEditButtonProps } from '../../components/EditButton/EditButton';
import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { trackCommentEdit } from './trackings';

type TEditButtonContainerDispatchProps = Pick<IEditButtonProps, 'onClick'>;
type TEditButtonContainerOwnProps = Pick<IEditButtonProps, 'entityId'>;

function mapDispatchToProps(dispatch: TThunkDispatch, { entityId }: TEditButtonContainerOwnProps) {
  return {
    onClick: bindActionCreators(() => startEditNote(entityId), dispatch),
  };
}

function mergeProps(
  state: IApplicationState,
  actions: TEditButtonContainerDispatchProps,
  ownProps: TEditButtonContainerOwnProps,
) {
  return {
    ...state,
    ...actions,
    ...ownProps,
    onClick: () => {
      actions.onClick();
      trackCommentEdit();
    },
  };
}

export const EditCommentButtonContainer = connect(null, mapDispatchToProps, mergeProps)(EditButton);
